<template>
  <div>
    <div class="col-xs-5 col-sm-5 col-md-5 col-xl-5 serviceleft">
      <div class="col-md-12 serviceHeader">
        <h1 class="servicetitle">Services</h1>
      </div>
    </div>
    <div class="col-xs-9 col-sm-9 col-md-9 col-xl-9 serviceright">
      <div class="serviceImage">
        <img alt="" src="aiImg/services/Services.png" style="max-height: 100%; object-fit: contain; padding:20px; padding-left:50px;"/>
      </div>
    </div>
    <div class="col-xs-6 col-sm-8 col-md-7 col-lg-6 serviceleft2">
      <div class="card12 " style="padding:0;  ">
        <div style="  background-color: rgba(0, 185, 174, .2); ">
<!--          <h5 class="description2" style="margin: 0; font-weight: 400; ">-->
<!--            AI Integration is a technologies company that specializes in integrating machine learning into software-->
<!--            solutions for commercial, government, and nonprofit organizations. Being a full life cycle software-->
<!--            solutions company, we provide our expertise in planning, design, development, testing, deployment,-->
<!--            and integration.-->
<!--          </h5>-->
          <h5 class="subtitle2" style="margin: 0; font-weight: 400; ">
            AI Integration enables customers to reach their technical goals and realize the potential solutions. Being
            a full life cycle software solutions company, we provide our expertise in planning, design, development,
            testing, deployment, and integration.
          </h5>
        </div>
      </div>
    </div>

    <div class="section serviceClear">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-10 ml-auto col-xl-10 mr-auto mainIndex">
            <!-- Machine Learning Section BEGIN-->
            <div class="col-xs-12 col-sm-12 col-md-12 ml-auto col-xl-12 mr-auto"
                 style="display: inline-block; padding:0; padding-top:20px; padding-bottom:20px;">
              <div class="col-xs-2 col-sm-3 col-md-3 col-xl-3 service4" style="float:left; ">
                <img alt="" class="TextImage" src="aiImg/services/AiIcon.png"/>
              </div>
              <div class="col-xs-9 col-sm-9 col-md-9 col-xl-9 service3" style="float:right;">
                <div class="subtitle text3" style="padding-left:0;font-size: 18px;">Machine Learning</div>
                AI Integration is an information technology company that specializes in deploying
                artificial intelligence into operational software environments for commercial, government, and
                nonprofit organizations.
              </div>
            </div>
            <div class="col-xs-6 col-sm-5 col-md-4 col-xl-4 service5 serviceBlocks">
              <img alt="" class="blockImage" src="aiImg/services/ObjectRecog.png" style="object-fit: contain;"/>
              <div class="middle">
                <div class="subtitle hovertext">Object Recognition</div>
                <div class="hovertext">
                  Computer vision task for detecting instances of objects in images and video.
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-5 col-md-4 col-xl-4 service5 serviceBlocks">
              <img alt="" class="blockImage" src="aiImg/services/ai 3.png" style="object-fit: contain;"/>
              <div class="middle">
                <div class="subtitle hovertext">Image Segmentation</div>
                <div class="hovertext">
                  Computer vision task that locates and creates a pixel-wise mask of objects in images and video.
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-5 col-md-4 col-xl-4 service5 serviceBlocks">
              <img alt="" class="blockImage" src="aiImg/services/ImplemCopy.png" style="object-fit: contain;"/>
              <div class="middle">
                <div class="subtitle hovertext">Speech to Text</div>
                <div class="hovertext">
                  Convert audio to text by applying powerful domain-optimized models.
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-5 col-md-4 col-xl-4 service5 serviceBlocks">
              <img alt="" class="blockImage" src="aiImg/services/AI Incon 2.png" style="object-fit: contain;"/>
              <div class="middle">
                <div class="subtitle hovertext">Text to Speech</div>
                <div class="hovertext">
                  Converts text input to audio speech.
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-5 col-md-4 col-xl-4 service5 serviceBlocks">
              <img alt="" class="blockImage" src="aiImg/services/AI4.png" style="object-fit: contain;"/>
              <div class="middle">
                <div class="subtitle hovertext">Anomaly Detection</div>
                <div class="hovertext">
                  Identifies data points, events, and/or observations that deviate significantly from a
                  dataset's normal behavior.
                </div>
              </div>
            </div>
            <div class="col-xs-6 col-sm-5 col-md-4 col-xl-4 service5 serviceBlocks">
              <img alt="" class="blockImage" src="aiImg/services/POwer.png" style="object-fit: contain;"/>
              <div class="middle">
                <div class="subtitle hovertext">Text identification</div>
                <div class="hovertext">
                  Extracts words from documents and images into machine-readable character streams.
                </div>
              </div>

            </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-6  aligncenter1">
            <div class="col-xs-12 col-sm-12 col-md-12 ml-auto col-xl-12 mr-auto"
                 style="display: inline-block; padding:0; padding-top:20px; ">
              <div class="col-xs-4 col-sm-4 col-md-4 col-xl-4 service4 " style="float:right;">
                <img alt="" class="TextImage4" src="aiImg/services/new icon.png"/>
              </div>
              <div class="col-xs-8 col-sm-8 col-md-8 col-xl-8 service3 " style="float:left;">
                <div class="subtitle text2" style="padding-left:0;">Other Machine Learning</div>
                <ul>
                  <li>Pattern finding in sparse data content</li>
                  <li>Algorithm Development & Implementation</li>
                  <li>Language identification</li>
                  <li>Character prediction</li>
                </ul>
              </div>
            </div>

            <!-- Machine Learning Section END -->
            <!-- Other Services BEGIN-->

              <div class="col-xs-12 col-sm-12 col-md-12 ml-auto col-xl-12 mr-auto padtop"
                   style="display: inline-block; padding:0; padding-top:60px; ">
                <div class="col-xs-4 col-sm-4 col-md-4 col-xl-4 service4 " style="float:left;">
                  <img alt="" class="TextImage4" src="aiImg/services/swe.png"/>
                </div>
                <div class="col-xs-8 col-sm-8 col-md-8 col-xl-8 service3" style="float:right;">
                  <div class="subtitle text2" style="padding-left:0;">Software Engineering</div>
                  <ul>
                    <li>Enterprise development</li>
                    <li>Web-based application development</li>
                    <li>Microservice applications</li>
                    <li>DevOps implementation</li>
                    <li>Process Automation</li>
                    <li>Agile Development</li>
                  </ul>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 ml-auto col-xl-12 mr-auto"
                   style="display: inline-block; padding:0; padding-top:60px; ">
                <div class="col-xs-4 col-sm-4 col-md-4 col-xl-4 service4 " style="float:right; ">
                  <img alt="" class="TextImage4" src="aiImg/services/CloudArc.png"/>
                </div>
                <div class="col-xs-8 col-sm-8 col-md-8 col-xl-8 service3 " style="float:left; ">
                  <div class="subtitle text2" style="padding-left:0;">Cloud Architecture</div>
                  <ul>
                    <li>Systems Engineering and Architecture</li>
                    <li>Development, Deployment, integration, administration</li>
                    <li>Data flow and Data ingest</li>
                    <li>Virtual Machine and Docker deployments</li>
                  </ul>
                </div>
              </div>

          </div>

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-6 aligncenter2">
              <div class="col-xs-12 col-sm-12 col-md-12 ml-auto col-xl-12 mr-auto"
                   style="display: inline-block; padding:0; padding-top:60px; ">
                <div class="col-xs-4 col-sm-4 col-md-4 col-xl-4 service4 smallfloat1">
                  <img alt="" class="TextImage4" src="aiImg/services/DataAnalysis.png"/>
                </div>
                <div class="col-xs-8 col-sm-8 col-md-8 col-xl-8 service3 smallfloat2">
                  <div class="subtitle text2" style="padding-left:0;">Data Analysis</div>
                  <ul>
                    <li>Work flow Management Solutions</li>
                    <li>Large Scale Management Implementations</li>
                    <li>Data Integration and Analytics</li>
                    <li>Data Mining</li>
                  </ul>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 ml-auto col-xl-12 mr-auto"
                   style="display: inline-block; padding:0; padding-top:60px; ">
                <div class="col-xs-4 col-sm-4 col-md-4 col-xl-4 service4 smallfloat2" >
                  <img alt="" class="TextImage4" src="aiImg/services/DevOps.png"/>
                </div>
                <div class="col-xs-8 col-sm-8 col-md-8 col-xl-8 service3 smallfloat1" >
                  <div class="subtitle text2" style="padding-left:0;">DevOps</div>
                  <ul>
                    <li>Designing and Implementing</li>
                    <li>Support and Use Integration with other systems</li>
                    <li>Deliver products faster and more efficiently with better value</li>
                  </ul>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 ml-auto col-xl-12 mr-auto padtop"
                   style="display: inline-block; padding:0; padding-top:60px; ">
                <div class="col-xs-4 col-sm-4 col-md-4 col-xl-4 service4 smallfloat1">
                  <img alt="" class="TextImage3" src="aiImg/services/Prototyping Option 2.png"/>
                </div>
                <div class="col-xs-8 col-sm-8 col-md-8 col-xl-8 service3 smallfloat2" >
                  <div class="subtitle text2" style="padding-left:0;">Prototyping</div>
                  <ul><li>Rapid Prototyping and Proof of Concept</li></ul>
                </div>
              </div>
            </div>
              <!-- Other Services END-->

          </div>
        </div>
      </div>
    </div>
    <br><br>

  </div>

</template>
<script>
import {Tabs, TabPane} from '@/components';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    Tabs,
    TabPane
  },
  data() {
    return {
      serviceType: 'Software Engineering'
    }

  }
};
</script>
<style>
.aligncenter2, .aligncenter1{
  display: inline-block !important;
  float: none !important;
}

.hovertext{
  padding:30px;
  padding-top:0;
}

.mark {
  background-color: #d30000 !important;
  color: black;
}

.smallfloat1{
  float: left;
}

.smallfloat2{
  float: right;
}

.serviceleft {
  margin-top: 90px;
  padding-right: 0;
  padding-left: 0 !important;
  z-index: 1;
}

.serviceleft2 {
  float: left;
  margin-top: -100px;
  padding-right: 0;
  padding-left: 0 !important;
  z-index: 1;
}

.serviceright {
  float: right;
  margin-top: -150px;
  padding-right: 0 !important;
  padding-left: 0;
  height: 400px;
}

.serviceClear {
  clear: both;
}

.serviceHeader {
  background-color: #00B9AE;
  color: #ffffff;
  height: 200px;
}

/*.serviceSubHeader {*/
/*  background-color: #dddddd;*/
/*  float: center;*/
/*  color: #222222;*/
/*  height: 200px;*/
/*  padding-right: 20px;*/
/*  padding-left: 20px;*/
/*  padding-top: 10px;*/
/*}*/

.serviceImage {
  background-color: #eeeeee;
  height: 400px;
  padding-left: 200px;
}

.servicetitle {
  text-align: center;
  font-weight: 500;
  padding-top: 70px;
}

.mainIndex {
  display: inline-block;
  padding: 0;
  padding-top: 20px;
  padding-bottom: 20px;
}

@media (max-width: 1199px){
  .serviceImage {
    padding-left:70px;
  }
}

@media (max-width: 767px) and (min-width: 576px) {
  .TextImage3{
    margin-top:20px !Important;
  }
  .TextImage4{
    margin-top:50px !Important;
  }
}

@media (max-width: 575px) {
  .TextImage3{
    margin-top:0px !Important;
  }
  .TextImage4{
    margin-top:20px !Important;
  }
}

@media (max-width: 991px) and (min-width: 767px){
  .TextImage3{
      margin-top:30px !Important;
      margin-bottom:0 !Important;
    }
    .TextImage4{
      margin-top:40px !Important;
      margin-bottom:0 !Important;
    }
}
@media (max-width: 1199px) and (min-width: 992px){
  .TextImage3{
      margin-top:30px !Important;
      margin-bottom:0 !Important;
    }
    .TextImage4{
      margin-top:30px !Important;
      margin-bottom:0 !Important;
    }
}

@media (min-width: 1200px) {
  .aligncenter1{
    padding-top: 60px !important;
    padding-right: 20px !important;
    float: left !important;
  }
  .aligncenter2{
    padding-top: 20px !important;
    padding-left: 20px !important;
    float: right !important;
  }
  .smallfloat1{
    float: right;
  }

  .smallfloat2{
    float: left;
  }
  .padtop{
    padding-top:80px !important;
  }
}

@media (max-width: 991px) {
  .hovertext{
    padding:10px !important;
  }
}

@media (max-width: 1199px) and (min-width: 991px) {
  .aligncenter2, .aligncenter1{
    margin-left: 60px !important;
    margin-right: 60px !important;
  }
}


@media (max-width: 767px) {
  .card12 {
    float: none;
    width: 95%;
    min-width: 200px;
    display: block;
  }

  .serviceleft2 {
    width: 100%;
  }

  .body {
    text-align: center;
  }
}


@media (max-width: 575px) {
  .card12 {
    margin-left: 0 !important;
    width: 80%;
    min-width: 0;
    display: block;
  }

  .serviceleft {
    float: left;
    margin-top: 0;
    height: 150px;
    width: 60% !important;
  }

  .serviceright {
    float: right;
    display: block;
    height: 200px;
    margin: 0;
  }

  .serviceleft2 {
    margin-top: -40px;
    float: left;
    display: block;
  }

  .serviceHeader {
    height: 150px;
  }

  .servicetitle {
    padding-top: 90px;
  }

  .serviceImage {
    background-color: #eeeeee;
    height: 200px;
    padding-top: 20px !important;
    padding-bottom: 20px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
    display: block;
    float: right;
    margin-top: -20px;
  }

  .description {
    text-align: center;
    padding-left: 4%;
    padding-right: 4%;
  }

  .service {
    text-align: center;
  }

  .mainIndex {
    padding: 20px !important;
  }
}


@media (max-width: 499px) {
  .serviceleft {
    width: 70% !important;
  }

  .serviceleft2 {
    margin-top: -60px;
  }

  .serviceImage {
    margin-top: -30px;
    width: 70%;
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .card12 {
    width: 90%;
  }
}
</style>
